<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.complaint_details") }}</h4>
    </div>
    <div class="col-12 text-end mb-3">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Ad Information Section ==== -->
      <div class="mb-4">
        <h5 class="section-title mb-3">
          {{ $t("PLACEHOLDERS.ad_information") }}
        </h5>
        <form>
          <div class="row">
            <!-- Start:: Ad Number -->
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.ad_number')"
              v-model.trim="data.ad_id"
              disabled
              class="disabled_input"
            />
            <!-- End:: Ad Number -->

            <!-- Start:: Ad Name (As Link) -->
               <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.ad_name')"
              v-model.trim="data.ad_name"
              disabled
              class="disabled_input"
            />
            <!-- End:: Ad Name -->

            <!-- Start:: Advertiser Name -->
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.advertiser_name')"
              v-model.trim="data.advertiser_name"
              disabled
              class="disabled_input"
            />
            <!-- End:: Advertiser Name -->

            <!-- Start:: Advertiser Mobile -->
            <base-input
              col="6"
              type="tel"
              :placeholder="$t('PLACEHOLDERS.advertiser_mobile')"
              v-model.trim="data.advertiser_mobile"
              disabled
              class="disabled_input"
            />
            <!-- End:: Advertiser Mobile -->
          </div>
        </form>
      </div>
      <!-- ==== End:: Ad Information Section ==== -->

      <!-- ==== Start:: Complaints List Section ==== -->
      <div class="complaints-section">
        <h5 class="section-title mb-3">
          {{ $t("PLACEHOLDERS.complaints_list") }}
        </h5>

        <!-- Start:: Complaints Table -->
        <v-data-table
          class="complaints-table"
          :headers="complaintsTableHeaders"
          :items="data.complaints"
          :items-per-page="10"
          hide-default-footer
        >
          <!-- Start:: No Data State -->
          <template v-slot:no-data>
            {{ $t("TABLES.noData") }}
          </template>
          <!-- End:: No Data State -->

          <!-- Start:: Complaint Number -->
          <template v-slot:[`item.id`]="{ item }">
            <h6>{{ item.id }}</h6>
          </template>
          <!-- End:: Complaint Number -->

          <!-- Start:: Complainant Name -->
          <template v-slot:[`item.user_name`]="{ item }">
            <h6 class="text-danger" v-if="!item.user?.name">
              {{ $t("TABLES.noData") }}
            </h6>
            <h6 v-else>{{ item.user.name }}</h6>
          </template>
          <!-- End:: Complainant Name -->

          <!-- Start:: Complainant Mobile -->
          <template v-slot:[`item.user_mobile`]="{ item }">
            <h6 class="text-danger" v-if="!item.user?.mobile">
              {{ $t("TABLES.noData") }}
            </h6>
            <h6 v-else>{{ item.user.mobile }}</h6>
          </template>
          <!-- End:: Complainant Mobile -->

          <!-- Start:: Complaint Reason -->
          <template v-slot:[`item.reason`]="{ item }">
            <h6 class="text-danger" v-if="!item.reason">
              {{ $t("TABLES.noData") }}
            </h6>
            <h6 v-else>{{ item.reason }}</h6>
          </template>
          <!-- End:: Complaint Reason -->

          <!-- Start:: Complaint Date -->
          <template v-slot:[`item.created_at`]="{ item }">
            <h6 class="text-danger" v-if="!item.created_at">
              {{ $t("TABLES.noData") }}
            </h6>
            <h6 v-else>{{ item.created_at }}</h6>
          </template>
          <!-- End:: Complaint Date -->
        </v-data-table>
        <!-- End:: Complaints Table -->
      </div>
      <!-- ==== End:: Complaints List Section ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowComplaint",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Complaints Table Headers
      complaintsTableHeaders: [
        {
          text: this.$t("TABLES.Reports.complaintNumber"),
          value: "id",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.complainantName"),
          value: "user_name",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.complainantMobile"),
          value: "user_mobile",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.complaintReason"),
          value: "reason",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("TABLES.Reports.complaintDate"),
          value: "created_at",
          align: "center",
          sortable: false,
        },
      ],
      // End:: Complaints Table Headers

      // Start:: Data
      data: {
        ad_id: null,
        ad_name: null,
        advertiser_name: null,
        advertiser_mobile: null,
        complaints: [],
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `ad-complaints/${this.$route.params.id}`,
        });

        const ad = res.data.data.ad;

        this.data.ad_id = ad.id;
        this.data.ad_name = ad.name;
        this.data.advertiser_name = ad.advertiser?.name || null;
        this.data.advertiser_mobile = ad.advertiser?.mobile || null;
        this.data.complaints = ad.complaints || [];
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || "حدث خطأ أثناء جلب البيانات"
        );
      }
    },
    // End:: Get Data To Show

    // Start:: Go To Ad Details
    goToAdDetails() {
      if (this.data.ad_id) {
        this.$router.push({ path: `/advertisements/show/${this.data.ad_id}` });
      }
    },
    // End:: Go To Ad Details
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>

<style scoped>
.section-title {
  font-weight: 700;
  color: #333;
  padding-bottom: 10px;
  border-bottom: 2px solid #26a1d6;
  margin-bottom: 20px;
}

.ad-name-link-container {
  padding: 10px 15px;
  background: #f5f5f5;
  border-radius: 8px;
  min-height: 45px;
  display: flex;
  align-items: center;
}

.ad-link:hover {
  color: #1a7aa8 !important;
}

.disabled_input {
  opacity: 1 !important;
}

.form-label {
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
  display: block;
}

.complaints-section {
  margin-top: 30px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 10px;
}

.complaints-table {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}
</style>
